import { t } from 'i18next';

import { toE164PhoneNumber } from '~utils/utilFunctions';

export const getPhoneValidationErrors = (
  phone: string | undefined,
  field: string,
): string[] =>
  phone?.trim() && !toE164PhoneNumber(phone)
    ? [t('csv_import_export.errors.invalid_phone', { field })]
    : [];
